<template>
  <div class="TravelPaymentTypeForm">
    <h2 class="gl_form-title">
      {{ t('travel.payment-type.legend') }}
    </h2>

    <RadioButtonGroup
      id="type"
      :value="paymentType"
      :options="paymentTypesOptions"
      v-model="paymentType"
      :rules="[validationRules.required]"
    />

    <div class="actions">
      <BaseButton
        :ariaDisabled="!isValidForm"
        type="primary"
        @click="emit('next')"
      >
        {{ t('copy_button_continue') }}
      </BaseButton>

      <BaseButton
        type="outlined"
        icon="icon-arrow-left"
        @click="emit('previous')"
      >
        {{ t('rater.base.back') }}
      </BaseButton>

      <BaseButton
        type="transparent"
        @click="exit"
      >
        {{ t('footer.exit') }}
      </BaseButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import BaseButton from '@/modules/core/components/ui/BaseButton.vue'
  import RadioButtonGroup from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'
  import { useRules } from '@/modules/core/composables/useRulesComposable'
  import GTMPageType from '@/modules/core/models/GTMPageType'
  import { useGTMStore } from '@/modules/core/stores/gtmStore'
  import { useLoadingStore } from '@/modules/core/stores/loadingStore'
  import type TravelConfigurations from '@/modules/travel/common/models/APP/TravelConfigurations'
  import router from '@/router'
  import { computed, onBeforeMount, ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import type TravelHiringAnswers from '../../models/APP/TravelHiringAnswers'

  const { t } = useI18n()
  const { required } = useRules()
  const loadingStore = useLoadingStore()
  const gtmStore = useGTMStore()

  defineExpose({ triggerSubmit })
  const emit = defineEmits(['next', 'previous'])
  interface PropsInterface {
    nextForm: String[]
    answers: TravelHiringAnswers
    configurations: TravelConfigurations
    isValidForm: boolean
  }
  const props = withDefaults(defineProps<PropsInterface>(), {})

  const paymentType = ref(
    String(props.answers.paymentType) ?? props.configurations.defaultPaymentType
  )
  const paymentTypesOptions = computed(() => props.configurations.paymentTypesOptions)
  const validationRules = {
    required
  }

  function triggerSubmit() {
    const page = props.nextForm[0]

    const answers = {
      paymentType: paymentType.value
    }
    return { page, answers }
  }

  function exit() {
    router.replace({ name: 'exit' })
  }

  onBeforeMount(() => {
    gtmStore.pageEvent(GTMPageType.CONTRATACION)
    loadingStore.stopLoading()
  })
</script>
<style lang="scss" scoped>
  .gl_form-title {
    margin-bottom: $spacing-xl;
  }
</style>
